import React from 'react'
import { useState } from 'react'
import Required from '../../../../Components/required/Required'
import { connect } from "react-redux";
import { handleAddHobby, handleDeleteHobby, handleUpdateHobby } from '../../../../services/actions/actions';

function ContentInterest({ intrests,setHandleAddHobby,setHandleUpdateHobby,setHandleDeleteHobby }) {
    const [isAddinInterest, setIsAddInterest] = useState(false)
    const [hobby,setHobby] = useState('')
    const [isEditing, setIsEditing] = useState(false)
    const [selectedId, setSelectedId] = useState('')
    const savesHobby = () => {
        const data = { hobby }
        setIsAddInterest(false)
        setHandleAddHobby(data)
        clearData()
    }
    const clearData = () => {
        setHobby('')
        setIsAddInterest(false)
        setIsEditing(false)
    }

    const openFormFromEdit = (id, data) => {
        setIsEditing(true)
        const { interest } = data;
        setHobby(interest)
        setSelectedId(id)
        setIsAddInterest(true)
    }

    const updateHobby = () => {
        const updated_data = { selectedId, hobby }
        setIsAddInterest(false)
        setHandleUpdateHobby(updated_data)
    }

    const deleteSkill = () => {
        setIsAddInterest(false)
        setHandleDeleteHobby(selectedId)
        clearData()
    }
    return (
        <>
            <div className='contentskill'>
                <div className='contentskill-container'>
                    {!isAddinInterest && <div>
                        <span className='block text-xs text-gray-500 py-3 italic'>Maximum of 6 Intrests/hobbies are allowed</span>
                        <div className='grid grid-cols-2 gap-3'>
                        {intrests.map((data, idx) => {
                            const { interest } = data
                            return <div key={idx} className=' cursor-pointer bg-gray-100 rounded-md px-4 py-2 hover:bg-gray-200' onClick={() => openFormFromEdit(idx, data)}>
                                <div className='flex justify-between items-center'>
                                    <span className='font-semibold text-lg text-gray-700 capitalize'>{interest}</span>
                                </div>
                            </div>
                        })}
                        </div>
                    </div>}

                    {isAddinInterest && <div className='contentskill-form'>
                        <div className="wm_form_group flex flex-col mb-4">
                            <label className="wm_form_label manpro font-semibold">Interest <Required /></label>
                            <input value={hobby} onChange={(e) => setHobby(e.target.value)} placeholder="Enter interest/hobby" type="text" name="skill" required className="wm_form_input border-bottom border-gray-300" />
                        </div>
                        <div className='text-center space-x-4'>
                            {!isEditing && <button className='manpro text-white px-3 py-1 rounded-md' style={{ 'backgroundColor': 'var(--color-5)' }} onClick={savesHobby}>Save</button>}
                            {isEditing && <button className='manpro text-white px-3 py-1 rounded-md' style={{ 'backgroundColor': 'var(--color-5)' }} onClick={updateHobby}>Update</button>}
                            {isEditing && <button className='manpro text-red-700 px-3 py-1 rounded-md bg-red-200' onClick={deleteSkill}>Delete</button>}
                            <button className='manpro text-gray-700 px-3 py-1 rounded-md border' style={{ 'borderColor': 'var(--color-5)' }} onClick={() => {setIsAddInterest(false);clearData()}}>Cancel</button>
                        </div>
                    </div>}
                    {intrests.length < 6 && !isAddinInterest && <div className='pt-3'>
                        <div className='text-center'>
                            <button className='manpro text-white px-3 py-1 rounded-md' style={{ 'backgroundColor': 'var(--color-5)' }} onClick={() => setIsAddInterest(true)}>Add interest</button>
                        </div>
                    </div>}
                </div>
            </div>
        </>
    )
}


const mapStateToProps = (state) => {
    return state;
};


const mapDispatchToState = (dispatch) => {
    return {
        setHandleAddHobby: (value) => {
            dispatch(handleAddHobby(value))
        },
        setHandleUpdateHobby: (value) => {
            dispatch(handleUpdateHobby(value))
        },
        setHandleDeleteHobby: (value) => {
            dispatch(handleDeleteHobby(value))
        },
    }
}

export default connect(mapStateToProps, mapDispatchToState)(ContentInterest)